import Vue from 'vue'
import VueRouter from 'vue-router'
import hierarchyRoutes from "./routes/hierarchy/routes"
import groupRoutes from "./routes/group/routes"
import questionnaireRoutes from "./routes/questionnaire/routes"
import ContentRoutes from "./routes/content/routes"

import workflow from "./routes/workflow/routes"

Vue.use(VueRouter)

const routes = [{
  path: '/Login',
  name: 'login',
  component: function () {
    return import('../views/Login.vue')
  },
},
{
  path: '/',
  name: 'Home',
  component: function () {
    return import('../views/Home.vue')
  },
  children: [
    groupRoutes,
    hierarchyRoutes,
    questionnaireRoutes,
    ContentRoutes,
    workflow
  ]
},
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router